import { ArrowRightOutlined, ClockCircleFilled } from '@ant-design/icons'
import { useSites } from '@api/useSites'
import { BBDTag, Horizontal, NotificationMessage, Texto, Vertical } from '@gravitate-js/excalibrr'
import { formatters } from '@utils/intl/dateTimeFormatters'
import { Button, TimePicker } from 'antd'
import moment from 'moment'
import React, { useEffect, useMemo, useState } from 'react'

export function UnavailableHours({ store, canEditStores }) {
  const { updateSiteMutation } = useSites()
  const { mutateAsync } = updateSiteMutation()
  // const onStartChange = (date) => {
  //   setTimeWindow({ ...timeWindow, start_hour: date })
  // }
  //
  // const onEndChange = (date) => {
  //   setTimeWindow({ ...timeWindow, end_hour: date })
  // }
  //
  // const handleDate = (date) => {
  //   return date ? moment(date).toISOString() : null
  // }
  //
  // const onStartSelect = (value) => {
  //   setTimeWindow({ ...timeWindow, start_hour: value })
  // }
  // const onEndSelect = (value) => {
  //   setTimeWindow({ ...timeWindow, end_hour: value })
  // }
  const sortedHours = useMemo(() => {
    if (store?.unavailable_hours?.length > 0) {
      const buckets = {}
      store.unavailable_hours.forEach((hour) => {
        if (hour.day_of_week in buckets) {
          buckets[hour.day_of_week].push(hour)
        } else {
          buckets[hour.day_of_week] = [hour]
        }
      })
      for (const day in buckets) {
        day.length > 0 && buckets[day].sort((a, b) => moment(a.start_hour) - moment(b.start_hour))
      }
      return buckets
    }
  }, [store?.unavailable_hours])

  const onSave = () => {
    console.log('save!')
    // const copy = { ...store, unavailable_hours: store.unavailable_hours || [] }
    // const windowCopy = { ...timeWindow }
    // windowCopy.start_hour = handleDate(windowCopy.start_hour)
    // windowCopy.end_hour = handleDate(windowCopy.end_hour)
    // copy.unavailable_hours[0] = windowCopy
    // mutateAsync(copy)
    //   .then(() => {
    //     NotificationMessage('Site Updated', 'Site unavailable hours have been updated.', false)
    //   })
    //   .catch((err) => {
    //     NotificationMessage('Problem saving unavailable hours', `ERROR: ${err}`, true)
    //   })
  }

  const enableSave = false //(!timeWindow.start_hour && !timeWindow.end_hour) || (timeWindow.start_hour && timeWindow.end_hour)

  return (
    <div className='full-height-width p-4 pl-3 text-gray-600 store-expand-card'>
      <Horizontal alignItems={'start'}>
        <Texto className={'text-truncate'}>
          <b className='text-size-5'>Unavailable Windows</b>
          &nbsp; You can manage these windows through the &nbsp;<em> Unavailable Hours </em>&nbsp; uploader.
        </Texto>
      </Horizontal>

      <Horizontal alignItems={'center'} className={'mt-4'}>
        <Vertical flex={1}>
          <Texto appearance={'hint'} category={'p2'}>
            MON
          </Texto>
        </Vertical>
        <Vertical flex={8}>
          <Horizontal>
            {!!sortedHours?.Monday?.length &&
              sortedHours.Monday.map((time, index) => (
                <BBDTag key={`${time.day_of_week}-${index}`} style={{ minWidth: 'fit-content' }} className={'m-1'}>
                  {formatters.TIME(time.start_hour, store.timezone)} - {formatters.TIME(time.end_hour, store.timezone)}
                </BBDTag>
              ))}
          </Horizontal>
        </Vertical>
      </Horizontal>

      <Horizontal alignItems={'center'} className={'mt-1'}>
        <Vertical flex={1}>
          <Texto appearance={'hint'} category={'p2'}>
            TUE
          </Texto>
        </Vertical>
        <Vertical flex={8}>
          <Horizontal style={{ width: '100%', flexWrap: 'wrap' }}>
            {!!sortedHours?.Tuesday?.length &&
              sortedHours.Tuesday.map((time, index) => (
                <BBDTag key={`${time.day_of_week}-${index}`} style={{ minWidth: 'fit-content' }} className={'m-1'}>
                  {formatters.TIME(time.start_hour, store.timezone)} - {formatters.TIME(time.end_hour, store.timezone)}
                </BBDTag>
              ))}
          </Horizontal>
        </Vertical>
      </Horizontal>

      <Horizontal alignItems={'center'} className={'mt-1'}>
        <Vertical flex={1}>
          <Texto appearance={'hint'} category={'p2'}>
            WED
          </Texto>
        </Vertical>
        <Vertical flex={8}>
          <Horizontal>
            {!!sortedHours?.Wednesday?.length &&
              sortedHours.Wednesday.map((time, index) => (
                <BBDTag key={`${time.day_of_week}-${index}`} style={{ minWidth: 'fit-content' }} className={'m-1'}>
                  {formatters.TIME(time.start_hour, store.timezone)} - {formatters.TIME(time.end_hour, store.timezone)}
                </BBDTag>
              ))}
          </Horizontal>
        </Vertical>
      </Horizontal>

      <Horizontal alignItems={'center'} className={'mt-1'}>
        <Vertical flex={1}>
          <Texto appearance={'hint'} category={'p2'}>
            THU
          </Texto>
        </Vertical>
        <Vertical flex={8}>
          <Horizontal>
            {!!sortedHours?.Thursday?.length &&
              sortedHours.Thursday.map((time, index) => (
                <BBDTag key={`${time.day_of_week}-${index}`} style={{ minWidth: 'fit-content' }} className={'m-1'}>
                  {formatters.TIME(time.start_hour, store.timezone)} - {formatters.TIME(time.end_hour, store.timezone)}
                </BBDTag>
              ))}
          </Horizontal>
        </Vertical>
      </Horizontal>

      <Horizontal alignItems={'center'} className={'mt-1'}>
        <Vertical flex={1}>
          <Texto appearance={'hint'} category={'p2'}>
            FRI
          </Texto>
        </Vertical>
        <Vertical flex={8}>
          <Horizontal>
            {!!sortedHours?.Friday?.length &&
              sortedHours.Friday.map((time, index) => (
                <BBDTag key={`${time.day_of_week}-${index}`} style={{ minWidth: 'fit-content' }} className={'m-1'}>
                  {formatters.TIME(time.start_hour, store.timezone)} - {formatters.TIME(time.end_hour, store.timezone)}
                </BBDTag>
              ))}
          </Horizontal>
        </Vertical>
      </Horizontal>

      <Horizontal alignItems={'center'} className={'mt-1'}>
        <Vertical flex={1}>
          <Texto appearance={'hint'} category={'p2'}>
            SAT
          </Texto>
        </Vertical>
        <Vertical flex={8}>
          <Horizontal>
            {!!sortedHours?.Saturday?.length &&
              sortedHours.Saturday.map((time, index) => (
                <BBDTag key={`${time.day_of_week}-${index}`} style={{ minWidth: 'fit-content' }} className={'m-1'}>
                  {formatters.TIME(time.start_hour, store.timezone)} - {formatters.TIME(time.end_hour, store.timezone)}
                </BBDTag>
              ))}
          </Horizontal>
        </Vertical>
      </Horizontal>

      <Horizontal alignItems={'center'} className={'mt-1'}>
        <Vertical flex={1}>
          <Texto appearance={'hint'} category={'p2'}>
            SUN
          </Texto>
        </Vertical>
        <Vertical flex={8}>
          <Horizontal>
            {!!sortedHours?.Sunday?.length &&
              sortedHours.Sunday.map((time, index) => (
                <BBDTag key={`${time.day_of_week}-${index}`} style={{ minWidth: 'fit-content' }} className={'m-1'}>
                  {formatters.TIME(time.start_hour, store.timezone)} - {formatters.TIME(time.end_hour, store.timezone)}
                </BBDTag>
              ))}
          </Horizontal>
        </Vertical>
      </Horizontal>
    </div>
  )
}
